import { NoticeTypes } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';

export const mapCaptions = (
  investment: Record<string, boolean | any>
): IconographyTypes.Option[] => {
  const captionKeys: Record<string, string> = {
    qualifiedInvestor: 'QualifiedClient',
    closedFund: 'Locked',
    professionalInvestor: 'ProfessionalInvestor',
    dailyLiquidity: 'Liquidity',
    taxExempt: 'IncomeTaxExempt',
    fgcProtected: 'Fgc',
    blocked: 'EyeOff',
  };

  return Object.keys(captionKeys)
    .filter((key) => investment[key])
    .map((key) => captionKeys[key]) as IconographyTypes.Option[];
};

const flatListMaxH = { base: '700px', sm: '600px', lg: '460px' };
const contentContainerStyle = {
  paddingBottom: Utils.Token.ToInt(Spacing, 'inset.nano'),
};

export const flatListProps = {
  maxToRenderPerBatch: 20,
  updateCellsBatchingPeriod: 5,
  showsVerticalScrollIndicator: false,
  maxH: flatListMaxH,
  onEndReachedThreshold: 0.4,
  contentContainerStyle,
};

export const noticeTotalSummaryDetail = [
  {
    text: 'Se você editar um ou mais ativos e confirmar, o cliente passará por uma nova validação. Certifique-se de revisar todas as informações antes de prosseguir.',
    variant: 'regular',
  },
] as NoticeTypes.TextObject[];

export const noticeRequiredAttentionDetail = [
  {
    text: 'Atenção: ',
    variant: 'bold',
  },
  {
    text: 'Ativos com informações divergentes não serão enviados. Por favor, verifique os ativos selecionados antes de prosseguir.',
    variant: 'regular',
  },
] as NoticeTypes.TextObject[];

export const noticeRequiredAttentionSection = [
  {
    text: 'Atenção: ',
    variant: 'bold',
  },
  {
    text: 'Clientes que requerem atenção não serão incluídos na lista de envio de boleta. Corrija os detalhes necessários.',
    variant: 'regular',
  },
] as NoticeTypes.TextObject[];

export const noticeBatchTicketSentSection = [
  { text: 'Atenção: ', variant: 'bold' },
  {
    text: 'Alguns clientes podem não possuir saldo disponível para este investimento. Por favor, solicite aos clientes o envio de recursos para realizar a operação.',
    variant: 'regular',
  },
] as NoticeTypes.TextObject[];

export * from './customer';
export * from './products';
export * from './PdfTemplate';
